import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentsLoader from "./documents-loader";
import { mapActions, mapGetters, mapState } from "vuex";
import { LOAD_DOCUMENTS, LOAD_REQUEST_LISTS, LOAD_DOCUMENT_TYPES, LOAD_DOCUMENT_LABELS } from "../store/documents-actions";
import DocumentsToolbar from "./documents-page/documents-toolbar";
import DocumentClassificationContainer from "./documents-page/document-classification-container";
import ClassificationSelectContainer from "./documents-page/document-classification/classification-select-container";
import ManageDocumentTagsModal from "@Broker/@Modules/clients/applications/documents/components/documents-page/document-classification/document-listing/manage-document-tags-modal.vue";
import SendDocumentsToLenderModal from "@Broker/@Modules/clients/applications/documents/components/documents-page/modals/send-documents-to-lender-modal.vue";
import RefreshButton from "@Shared/components/buttons/refresh-button.vue";
import { defineComponent } from "@vue/composition-api";
import { DOCUMENTS_FOR_APPLICATION } from "../store/documents-getters";
export default defineComponent({
  name: "DocumentsContainer",
  title() {
    return this.$t("sidebar.sections.application.documents");
  },
  components: {
    RefreshButton,
    DocumentsLoader,
    DocumentsToolbar,
    DocumentClassificationContainer,
    ClassificationSelectContainer,
    ManageDocumentTagsModal,
    SendDocumentsToLenderModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      refreshing: false,
      labelName: "",
      documentsToSend: [],
      lenderName: "",
      submission: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    clientDetails(state) {
      return state.clients[this.clientUsername] || {};
    }
  })), mapGetters("DocumentsStore", [DOCUMENTS_FOR_APPLICATION])), {}, {
    documentListEmpty() {
      const documennts = this.DOCUMENTS_FOR_APPLICATION(this.applicationId);
      return _Object$keys(documennts.byId).length === 0;
    }
  }),
  mounted() {
    this.loadDocuments();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [LOAD_DOCUMENTS, LOAD_REQUEST_LISTS, LOAD_DOCUMENT_TYPES, LOAD_DOCUMENT_LABELS])), {}, {
    async loadDocuments() {
      const promises = [this.LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      }), this.LOAD_REQUEST_LISTS(), this.LOAD_DOCUMENT_TYPES(), this.LOAD_DOCUMENT_LABELS()];
      await _Promise.all(promises);
      this.loading = false;
    },
    async refreshDocuments() {
      this.refreshing = true;
      await this.loadDocuments();
      this.refreshing = false;
    },
    openTagsModal(name = "") {
      this.labelName = name;
      this.$refs.tagsModal.$showModal();
    },
    openDocumentsContainer(submission) {
      const documents = this.DOCUMENTS_FOR_APPLICATION(this.applicationId);
      const applicationDocuments = _Object$values(documents.byId);
      if (submission.documentsSent) {
        this.documentsToSend = _filterInstanceProperty(applicationDocuments).call(applicationDocuments, ad => {
          var _context;
          return !_includesInstanceProperty(_context = submission.documentsSent).call(_context, ad.documentId);
        });
      } else this.documentsToSend = applicationDocuments;
      this.submission = submission;
      this.lenderName = submission.lenderName;
      this.$refs.sendDocumentsToLenderModal.$showModal();
    }
  })
});